// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ijf-A","buttons":"styles_buttons__2JhdX"};